import React from "react";
import "./UnderConstruction.css";

const UnderConstruction = () => {
  return (
    <div className="container" data-testid="under-construction">
      <h1 className="construction-title">Under Construction</h1>
    </div>
  );
};
export default UnderConstruction;
